export const ADDRESS_FORM_NAME = 'address';

export const CLIENT_NAME_FIELD_NAME = 'name';

export const CONTACT_NAME_FIELD_NAME = 'contactName';

export const PHONE_NUMBER_FIELD_NAME = 'phone';

export const EMAIL_FIELD_NAME = 'email';

export const TEST_ID = 'clientFormFields';
